<template>
  <section class="nav-menu">
    <b-tabs v-model="activeTab" expanded class="block nav-menu__tabs">
      <b-tab-item :label="localization('app-feature-types','Feature Types')">
        <feature-type-list></feature-type-list>
      </b-tab-item>
      <b-tab-item :label="localization('app-rasters','Rasters')">
        <project-group-list></project-group-list>
      </b-tab-item>
    </b-tabs>
  </section>
</template>
<script>
import FeatureTypeList from "./components/features-type/feature-type-list.component";
import ProjectGroupList from "./components/projects/project-group-list.component";

export default {
  data() {
    return {
      activeTab: 1
    };
  },
  components: {
    FeatureTypeList,
    ProjectGroupList
  }
};
</script>
<style lang="scss" >
.nav-menu {
  .tab-content {
    padding: 1rem 3px;
    text-align: center;
  }
  .tabs ul {
    margin-left: 0;
    font-size: 0.9rem;
  }
  .tabs li {
    text-transform: capitalize;
  }
  .tabs a {
    border-bottom-width: 3px;
    border-bottom-color: transparent;
    color: #171e48;
    opacity: 0.5;
    font-family: Barlow-SemiBold !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important; 
    padding: 0;
  }
  .tabs li a span {
    color: #171e48;
    border-bottom: 0;
    padding-top: 1rem;
    padding-bottom: 17px;
  }

  .tabs li.is-active a {
    border-bottom: 0;
    opacity: 1;
  }

  .tabs li.is-active a span {
    border-bottom: 3px solid #2585d3;
  }
}
.content .nav-menu li + li {
  margin-top: 0 !important;
}
</style>
